import { router, routerFuns } from "sw-hic";
import { dictIndex, reportIndex } from "../../packages/masterdata";
routerFuns.init([
  {
    path: "/tenant",
    name: "tenant",
    component: () => import("@/components/tenant/index"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dept",
    name: "dept",
    component: () => import("@/components/dept/index"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/staff",
    name: "staff",
    component: () => import("@/components/staff/index"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/role",
    name: "role",
    component: () => import("@/components/role/index"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/apply",
    name: "apply",
    component: () => import("@/components/apply/index"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/room",
    name: "room",
    component: () => import("@/components/deptRoom/index"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dict",
    name: "dict",
    component: dictIndex,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/setting",
    name: "setting",
    component: () => import("@/components/setting/setting"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/frequency",
    name: "frequency",
    component: () => import("@/components/frequency/index"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/menus",
    name: "menus",
    component: () => import("@/components/menus/index"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/report",
    name: "report",
    component: () => import("@/components/report/index"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/reportIndex",
    name: "reportIndex",
    component: reportIndex,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/tabu",
    name: "tabu",
    component: () => import("@/components/tabu/index"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/print",
    name: "print",
    component: () => import("@/components/print/index"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/examineCode",
    name: "examineCode",
    component: () => import("@/components/examineCode/index"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/examineItem",
    name: "examineItem",
    component: () => import("@/components/examineItem/index"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/examineSet",
    name: "examineSet",
    component: () => import("@/components/examineSet/index"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/therapyCode",
    name: "therapyCode",
    component: () => import("@/components/therapy/index"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/therapyItem",
    name: "therapyItem",
    component: () => import("@/components/therapyItem/index"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/fee",
    name: "fee",
    component: () => import("@/components/feeStandard/index"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/pxyDb",
    name: "pxyDb",
    component: () => import("@/components/proxy/db/index"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/pxyQuery",
    name: "pxyQuery",
    component: () => import("@/components/proxy/query/index"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/pxySetting",
    name: "pxySetting",
    component: () => import("@/components/proxy/setting/index"),
    meta: {
      requiresAuth: true,
    },
  },

]);

export default router;
